<template>
  <div>
    h5 layout
    <router-view />
  </div>
</template>

<script>
  export default {};
</script>

<style></style>
